import { EntitySponsor } from "../../entity/EntitySponsor";

export class DtoSponsorsDeleteRes extends EntitySponsor {
  public message: string | null = null;
}
